export default __webpack_public_path__ + "static/media/team-1.5565c8d6.jpg";